import { useEffect, useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

const ADD_SPACE_LINK = 'adg3.ConfigurableSpaceSidebar.addSpaceLink';
const REMOVE_SPACE_LINK = 'adg3.ConfigurableSpaceSidebar.removeSpaceLink';

export const useSidebarConfigurationListener = (
	addSpaceLink, //arg functions are passed as refs as destructure from useMutation
	removeSpaceLink,
) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const addSpaceLinkInner = useCallback(
		(e: any) => {
			// Temporary analytics event to check usage
			createAnalyticsEvent({
				type: 'sendOperationalEvent',
				data: {
					action: 'called',
					actionSubject: 'addSpaceLink',
					source: 'sidebarConfiguration',
				},
			}).fire();

			const { spaceKey, id } = e.detail;
			addSpaceLink({ variables: { spaceKey, id } });
		},
		[addSpaceLink, createAnalyticsEvent],
	);

	const removeSpaceLinkInner = useCallback(
		(e: any) => {
			// Temporary analytics event to check usage
			createAnalyticsEvent({
				type: 'sendOperationalEvent',
				data: {
					action: 'called',
					actionSubject: 'removeSpaceLink',
					source: 'sidebarConfiguration',
				},
			}).fire();

			const { spaceKey, id } = e.detail;
			removeSpaceLink({ variables: { spaceKey, id } });
		},
		[removeSpaceLink, createAnalyticsEvent],
	);

	useEffect(() => {
		window.addEventListener(ADD_SPACE_LINK, addSpaceLinkInner);
		window.addEventListener(REMOVE_SPACE_LINK, removeSpaceLinkInner);

		return () => {
			window.removeEventListener(ADD_SPACE_LINK, addSpaceLinkInner);
			window.removeEventListener(REMOVE_SPACE_LINK, removeSpaceLinkInner);
		};
	}, [addSpaceLinkInner, removeSpaceLinkInner]);
};
